export const setSubscribePlans = 'setSubscribePlans'
export const setChosenPlan = 'setChosenPlan'
export const setBasicSeller = 'setBasicSeller'



// WEBPACK FOOTER //
// ./src/app/pages/subscribe/vuex/mutations-types.js